import { Helmet } from 'react-helmet'
import React from 'react'
import { string } from 'prop-types'
import favicon from '../../assets/imagens/favicon.png'
import { RECAPTCHA_SCRIPT_SRC } from '../../utils/recaptcha'

export default function Head( { title, description, ...props } ) {
  return (
    <Helmet { ...props }>
      <link
        href={ favicon }
        rel="shortcut icon"
        sizes="16x16"
        type="image/png"
      />
      <title>
        {title}
      </title>
      <meta
        content={ description }
        name="description"
      />
      <script
        async
        defer
        src={ `${RECAPTCHA_SCRIPT_SRC}?render=explicit` }
      />
    </Helmet>
  )
}

Head.defaultProps = {
  'description': '',
  'title': ''
}

Head.propTypes = {
  'description': string,
  'title': string,
  ...Helmet.propTypes
}
